import React from 'react';

import { Checkbox as AntdCheckbox } from 'antd';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';

import { FilterButton } from 'components/WrappedComponents';
import { FilterDashboardUniteFo } from 'types/referentiels/UniteFo';

import FilterFormUniteFo from './FilterFormUniteFo';

interface FilterProps {
  setFilter: (value: Partial<FilterDashboardUniteFo>) => void;
  filter: Partial<FilterDashboardUniteFo>;
}

export default function Filter({
  filter,
  setFilter,
}: FilterProps): React.ReactElement {
  const { valid, ...formFilter } = filter;
  function setFormFilter(value: Partial<FilterDashboardUniteFo>) {
    setFilter({
      ...filter,
      ...value,
    });
  }

  function setDisplayInvalidUniteFo(event: CheckboxChangeEvent) {
    setFilter({
      ...filter,
      valid: !event.target.checked,
    });
  }

  return (
    <div className="dashboard-header-filter">
      <FilterButton
        filter={formFilter}
        setFilter={setFormFilter}
        textInactiveFilter="Filtres"
        textActiveFilter="Filtres (actifs)"
      >
        {(setData, data) => (
          <FilterFormUniteFo filter={data} setFilter={setData} />
        )}
      </FilterButton>
      <AntdCheckbox
        checked={!valid}
        onChange={setDisplayInvalidUniteFo}
        className="checkbox-unites-inactives"
      >
        Afficher les unités FO inactives
      </AntdCheckbox>
    </div>
  );
}
